<template>
  <div :class="['change-section', subclass]">
    <div class="container">
      <div class="row no-margin">
        <div class="col-l-12 col-m-12 col-s-12">
          <h2>{{ blockdata.name }}</h2>
        </div>
        <div class="col-l-3 col-m-4 col-s-12">
          <ul class="list">
            <li
              v-on:click="switchPage(slug(element.name), pageSlug)"
              v-for="(element, index) in elements"
              :key="index"
              :class="['item', { active: slug(element.name) === currentItem }]"
            >
              <a>{{ element.name }}</a>
            </li>
          </ul>
        </div>
        <div class="col-l-6 col-m-8 col-s-12">
          <div
            class="content"
            v-for="(element, index) in elements"
            :key="index"
            v-if="slug(element.name) === currentItem"
          >
            <div v-html="element.content"></div>
            <div
              v-for="(download, downloadindex) in element.downloads"
              :key="downloadindex"
            >
              <a
                v-if="download.file.url"
                :href="download.file.url"
                target="_blank"
                class="btn default"
                download
                >{{ download.file.title }}</a
              >
            </div>
          </div>
        </div>
        <div class="col-l-3 col-m-8 col-m-offset-4 col-s-12">
          <div
            class="more-info"
            v-for="(element, index) in elements"
            :key="index"
            v-html="element.moreinfo"
            v-if="slug(element.name) === currentItem"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scroller } from "vue-scrollto/src/scrollTo";
const slugify = require("slugify");

export default {
  props: ["blockdata", "pageSlug"],
  name: "change-section",
  data() {
    return {
      elements: this.blockdata.elements,
      subclass: this.blockdata.sub_class,
      currentItem: this.$route.params.slug
        ? this.$route.params.slug
        : this.slug(
            this.blockdata.elements[0] ? this.blockdata.elements[0].name : ""
          ),
    };
  },
  mounted() {
    if (this.$route.params.slug) {
      const firstScrollTo = scroller();
      firstScrollTo("#link-0");
    }
  },
  methods: {
    slug(title) {
      return slugify(title, {
        lower: true,
        strict: true,
        locale: "en",
      });
    },
    switchPage(slug, pageSlug) {
      this.currentItem = slug;
      window.history.pushState(
        {},
        document.title,
        "/" + (pageSlug === undefined ? "services" : pageSlug) + "/" + slug
      );
    },
  },
};
</script>

<style lang="scss" scope>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.75s;
}
.fade-enter-active {
  transition-delay: 0.75s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.content + .content {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// ChangeSection.vue?0c9e6f72